__turbopack_context__.v({
  "byline": "recipe-hero-module__rqfbSW__byline",
  "bylineLink": "recipe-hero-module__rqfbSW__bylineLink",
  "category": "recipe-hero-module__rqfbSW__category",
  "content": "recipe-hero-module__rqfbSW__content",
  "controls": "recipe-hero-module__rqfbSW__controls",
  "description": "recipe-hero-module__rqfbSW__description",
  "dietaryBadges": "recipe-hero-module__rqfbSW__dietaryBadges",
  "eyebrow": "recipe-hero-module__rqfbSW__eyebrow",
  "hero": "recipe-hero-module__rqfbSW__hero",
  "heroFadeUp": "recipe-hero-module__rqfbSW__heroFadeUp",
  "imageOverlayActions": "recipe-hero-module__rqfbSW__imageOverlayActions",
  "imageOverlayActionsStart": "recipe-hero-module__rqfbSW__imageOverlayActionsStart",
  "imageWrapper": "recipe-hero-module__rqfbSW__imageWrapper",
  "meta": "recipe-hero-module__rqfbSW__meta",
  "metaIcon": "recipe-hero-module__rqfbSW__metaIcon",
  "metaItem": "recipe-hero-module__rqfbSW__metaItem",
  "metaLabel": "recipe-hero-module__rqfbSW__metaLabel",
  "metaSub": "recipe-hero-module__rqfbSW__metaSub",
  "metaValue": "recipe-hero-module__rqfbSW__metaValue",
  "mobileActions": "recipe-hero-module__rqfbSW__mobileActions",
  "servesBtn": "recipe-hero-module__rqfbSW__servesBtn",
  "servesBtnIcon": "recipe-hero-module__rqfbSW__servesBtnIcon",
  "servesControl": "recipe-hero-module__rqfbSW__servesControl",
  "title": "recipe-hero-module__rqfbSW__title",
});
